import { render, staticRenderFns } from "./ChannelErrorPage.vue?vue&type=template&id=6eac1c54&scoped=true"
import script from "./ChannelErrorPage.vue?vue&type=script&lang=js"
export * from "./ChannelErrorPage.vue?vue&type=script&lang=js"
import style0 from "./ChannelErrorPage.vue?vue&type=style&index=0&id=6eac1c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eac1c54",
  null
  
)

export default component.exports